var React = require('react');

function IconCloseModal (props) {
    return React.createElement("svg",props,React.createElement("path",{"fill":"#444","fillRule":"nonzero","d":"M21 2.12L18.88 0 10.5 8.38 2.12 0 0 2.12l8.38 8.38L0 18.88 2.12 21l8.38-8.38L18.88 21 21 18.88l-8.38-8.38z"}));
}

IconCloseModal.displayName = "IconCloseModal";

IconCloseModal.defaultProps = {"width":"21","height":"21","viewBox":"0 0 21 21"};

module.exports = IconCloseModal;

IconCloseModal.default = IconCloseModal;



//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/iconCloseModal.svg
// module id = 406
// module chunks = 22